import { ADDED_DATE_LABEL } from "../../../utils/constants";
import { USER_ID_COLUMN_LABEL } from "../../../utils/registrationValidationStrings";

// Column model for the Users List table: order, labels, which columns sort.
// Widths live in users-list-bwai.css, one rule per `key` for heading and cell.
export const USERS_COLUMNS = [
  { key: "name", label: "Name", sortable: true },
  { key: "email", label: "Email", sortable: true },
  { key: "employeeId", label: USER_ID_COLUMN_LABEL, sortable: true },
  { key: "mobileNumber", label: "Mobile Number", sortable: true },
  { key: "addedDate", label: ADDED_DATE_LABEL, sortable: true },
  { key: "role", label: "Role", sortable: true },
  { key: "actions", label: "", sortable: false },
];

// Once a column has been dragged, `columnWidths` holds every column's share (%)
// and overrides the CSS default for both the heading cell and its row cell.
export const columnWidthStyle = (columnWidths, key) => {
  if (!columnWidths || columnWidths[key] === undefined) return undefined;
  const width = `${columnWidths[key]}%`;
  return { flex: `0 0 ${width}`, maxWidth: width };
};

// Dragged widths are kept per user in this browser, so they survive reloads.
const columnWidthsStorageKey = (userId) => `usersListColumnWidths:${userId}`;

// A saved layout must have exactly the current columns and fill the row. One
// saved for a different column set (a column added or removed since) would
// leave a gap at the end or overflow, so it is dropped and the CSS defaults
// apply instead.
export const loadColumnWidths = (userId) => {
  try {
    const saved = JSON.parse(localStorage.getItem(columnWidthsStorageKey(userId)));
    if (!saved || typeof saved !== "object") return null;
    const isComplete = USERS_COLUMNS.every(
      (column) => typeof saved[column.key] === "number" && saved[column.key] >= 0
    );
    const hasExtraColumns = Object.keys(saved).length !== USERS_COLUMNS.length;
    if (!isComplete || hasExtraColumns) return null;
    const total = USERS_COLUMNS.reduce((sum, column) => sum + saved[column.key], 0);
    if (Math.abs(total - 100) > 1) return null;
    return saved;
  } catch (error) {
    return null;
  }
};

export const saveColumnWidths = (userId, columnWidths) => {
  try {
    localStorage.setItem(columnWidthsStorageKey(userId), JSON.stringify(columnWidths));
  } catch (error) {
    // Storage blocked or full: the widths still apply for this visit.
  }
};
